<template>
  <el-card style="margin-top: 20px">
    <el-row class="title-biaoti">节点配置</el-row>
    <el-row class="search">
      <el-input
        v-model="queryNodeInfo.taskLevel"
        placeholder="任务档位"
        clearable
      />
      <el-input
        v-model="queryNodeInfo.levelNode"
        placeholder="档位节点"
        clearable
      />
      <el-select v-model="queryNodeInfo.valid" placeholder="是否有效">
        <el-option label="全部" value="" />
        <el-option label="有效" value="1" />
        <el-option label="无效" value="0" />
      </el-select>
      <el-button type="primary" @click="query" :loading="login">
        查询
      </el-button>
      <el-button type="primary" @click="operate(1)"> 新增 </el-button>
    </el-row>
    <el-row>
      <el-table height="65vh" :data="dataList1" v-loading="login">
        <el-table-column prop="taskLevel" label="任务档位" align="center" />
        <el-table-column prop="levelNode" label="档位节点" align="center" />
        <el-table-column prop="nodeName" label="节点名字" align="center" />
        <el-table-column prop="nodeDesc" label="节点描述" align="center" />
        <el-table-column
          prop="timeSCondition"
          label="节点条件"
          align="center"
        />
        <el-table-column prop="rewardNums" label="奖励数量" align="center" />
        <el-table-column
          prop="btimeSCondition"
          label="b档节点条件"
          align="center"
        />
        <el-table-column
          prop="brewardNums"
          label="b档奖励数量"
          align="center"
        />
        <el-table-column prop="bcondition" label="b档触发天数" align="center" />

        <el-table-column prop="valid" label="是否有效" align="center">
          <!-- 是否可用valid，0/1 -->
          <template slot-scope="scope">
            <el-tag v-if="scope.row.valid == 0" type="danger">无效</el-tag>
            <el-tag v-else type="success">有效</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="ctimeStr" label="创建时间" align="center" />
        <el-table-column prop="mtimeStr" label="修改时间" align="center" />
        <el-table-column prop="operator" label="操作人" align="center" />

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="operate(2, scope.row)"
            >
              编辑
            </el-button>
          </template>
        </el-table-column></el-table
      >
    </el-row>
    <el-pagination
      @current-change="handleCurrentChange2"
      :current-page="paginationInfo.page"
      :page-size="paginationInfo.pageSize"
      layout="total, prev, pager, next, jumper"
      :total="paginationInfo.total"
    />
    <el-dialog
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form :model="form" label-width="100px">
        <!-- 任务档位taskLevel、档位节点levelNode、节点条件timeSCondition、奖励数量rewardNums、节点名字nodeName、是否有效valid、节点描述nodeDesc -->
        <el-form-item label="任务档位" prop="taskLevel">
          <el-input v-model="form.taskLevel" />
        </el-form-item>
        <el-form-item label="档位节点" prop="levelNode">
          <el-input v-model="form.levelNode" />
        </el-form-item>
        <el-form-item label="节点条件" prop="timeSCondition">
          <el-input v-model="form.timeSCondition" />
        </el-form-item>
        <el-form-item label="奖励数量" prop="rewardNums">
          <el-input v-model="form.rewardNums" />
        </el-form-item>
        <el-form-item label="节点名字" prop="nodeName">
          <el-input v-model="form.nodeName" />
        </el-form-item>
        <el-form-item label="是否有效" prop="valid">
          <el-select v-model="form.valid" placeholder="是否有效">
            <el-option label="有效" value="1" />
            <el-option label="无效" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="节点描述" prop="nodeDesc">
          <el-input v-model="form.nodeDesc" />
        </el-form-item>
        <el-form-item label="b档节点条件" prop="btimeSCondition">
          <el-input type="number" v-model.number="form.btimeSCondition" />
        </el-form-item>
        <el-form-item label="b档奖励数量" prop="brewardNums">
          <el-input type="number" v-model.number="form.brewardNums" />
        </el-form-item>
        <el-form-item label="b档触发天数" prop="bcondition">
          <el-input type="number" v-model.number="form.bcondition" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import { UTCTimeToDate } from '@/utils/common'
export default {
  data() {
    return {
      dataList1: [],
      login: false,
      queryNodeInfo: {
        taskLevel: '',
        valid: '',
        levelNode: '',
      },
      paginationInfo: {
        total: 0,
        pageSize: 30,
        page: 1,
      },
      isAdd: true,
      dialogVisible: false,
      form: {
        taskLevel: '',
        levelNode: '',
        timeSCondition: '',
        rewardNums: '',
        nodeName: '',
        valid: '',
        nodeDesc: '',
        btimeSCondition: null,
        brewardNums: null,
        bcondition: null,
      },
    }
  },
  async created() {
    this.query()
  },
  methods: {
    async query(page) {
      if (page) this.paginationInfo.page = 1
      this.login = true
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_room_node_query +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        {
          page: this.paginationInfo.page,
          pageSize: this.paginationInfo.pageSize,
          taskLevel: this.queryNodeInfo.taskLevel,
          valid: this.queryNodeInfo.valid,
          levelNode: this.queryNodeInfo.levelNode,
        }
      )
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.dataList1 = res.data.resultList
      this.paginationInfo.total = res.data.totalPages
      this.dataList1.map((item) => {
        if (item.ctime !== 0)
          item.ctimeStr = UTCTimeToDate(item.ctime, 'yyyy-MM-dd HH:mm:ss')
        if (item.mtime !== 0)
          item.mtimeStr = UTCTimeToDate(item.mtime, 'yyyy-MM-dd HH:mm:ss')
      })
    },
    submit() {
      if (this.isAdd) {
        this.add()
      } else {
        this.edit()
      }
    },
    operate(type, row) {
      this.isAdd = type == 1
      if (type == 2) {
        // 将valid转换为字符串
        row.valid = row.valid + ''
        this.form = row
      }
      this.dialogVisible = true
    },
    async add() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_room_node_create +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        this.form
      )
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success('新增成功')
      this.handleClose()
      this.query()
    },
    async edit() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_room_node_update +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        this.form
      )
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success('编辑成功')
      this.handleClose()
      this.query()
    },
    handleClose() {
      this.dialogVisible = false
      this.form = {
        taskLevel: '',
        levelNode: '',
        timeSCondition: '',
        rewardNums: '',
        nodeName: '',
        valid: '',
        nodeDesc: '',
        btimeSCondition: null,
        brewardNums: null,
        bcondition: null,
      }
    },
    handleCurrentChange2(val) {
      this.paginationInfo.page = val
      this.query()
    },
  },
}
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  > * {
    margin: 0 5px;
  }
  .el-input {
    width: 200px;
  }
}
</style>
